





























import Vue from "vue";

export default Vue.extend({
  props: {
    dmsParam: {
      type: Object,
      default: Object,
    },
    dmsKey: {
      type: String,
      default: String,
    },
    dmsIndex: {
      type: Number,
      default: Number,
    },
    maxValue: {
      type: Number,
      default: Number,
    },
    minValue: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      checkType: "",
      checkType3: "",
      error: "",
      regexReal: new RegExp(/^([1-9]\d*|0)(\.\d+)?$/),
      regexcheck: new RegExp(/^(-?[0-9])+(.?[0-9]*)$/),
      regexstringcheck: new RegExp(
        /^-?[0-9]{1,3}?(:[0-5]?[0-9]){0,2}?\.?[0-9]*$/
      ),
      regexInteger: new RegExp(/^[0-9]+$/),
    };
  },
  watch: {
    dmsParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      if (this.dmsKey === "stdpal") {
        this.checkType = this.dmsParam[this.dmsKey][this.dmsIndex];
      }
      if (this.dmsKey !== "stdpal") {
        this.checkType3 = this.dmsParam[this.dmsKey];
      }
    },
    SendDMS() {
      this.$emit("DMSEvent");
    },
    ChangeStdpal(Argument: string) {
      if (!this.regexstringcheck.test(String(Argument))) {
        this.error = "正しい値を入力してください";
        this.$emit("hasError", false);
        if (this.dmsIndex == 0) {
          this.dmsParam[this.dmsKey] = [null, this.dmsParam[this.dmsKey][1]];
        }
        if (this.dmsIndex == 1) {
          this.dmsParam[this.dmsKey] = [this.dmsParam[this.dmsKey][0], null];
        }
        return;
      }
      let test = Number(Argument);
      if (isNaN(Number(Argument))) {
        const ary = String(Argument).split(":");
        const deg = parseInt(ary[0], 10);
        if (!isFinite(deg)) {
          test = 0;
        }
        const min = parseInt(ary[1], 10);
        if (!isFinite(min) || min >= 60 || min < 0) {
          test = deg;
        }
        const sec = parseFloat(ary[2]);
        if (!isFinite(sec) || sec >= 60 || sec < 0) {
          test = deg + min / 60.0;
        } else {
          test = deg + min / 60.0 + sec / 3600.0;
        }
        // if (ary[3] === "S") {
        //   lat *= -1;
        // }
      }
      if (test > this.maxValue) {
        this.error = this.maxValue + "以下の値を指定してください";
        this.$emit("hasError", false);
        if (this.dmsIndex == 0) {
          this.dmsParam[this.dmsKey] = [null, this.dmsParam[this.dmsKey][1]];
        }
        if (this.dmsIndex == 1) {
          this.dmsParam[this.dmsKey] = [this.dmsParam[this.dmsKey][0], null];
        }
        return;
      }
      if (test < this.minValue) {
        this.error = this.minValue + "以上の値を指定してください";
        this.$emit("hasError", false);
        if (this.dmsIndex == 0) {
          this.dmsParam[this.dmsKey] = [null, this.dmsParam[this.dmsKey][1]];
        }
        if (this.dmsIndex == 1) {
          this.dmsParam[this.dmsKey] = [this.dmsParam[this.dmsKey][0], null];
        }
        return;
      }
      if (this.dmsIndex == 0) {
        this.dmsParam[this.dmsKey] = [test, this.dmsParam[this.dmsKey][1]];
      }
      if (this.dmsIndex == 1) {
        this.dmsParam[this.dmsKey] = [this.dmsParam[this.dmsKey][0], test];
      }
      this.error = "";
      this.$emit("hasError", true);
    },
    CheckNumber(Argument: string) {
      if (!this.regexstringcheck.test(String(Argument))) {
        this.error = "正しい値を入力してください";
        this.$emit("hasError", false);
        this.dmsParam[this.dmsKey] = null;
        return;
      }
      let test = Number(Argument);
      if (isNaN(Number(Argument))) {
        const ary = String(Argument).split(":");
        const deg = parseInt(ary[0], 10);
        if (!isFinite(deg)) {
          test = 0;
        }
        const min = parseInt(ary[1], 10);
        if (!isFinite(min) || min >= 60 || min < 0) {
          test = deg;
        }
        const sec = parseFloat(ary[2]);
        if (!isFinite(sec) || sec >= 60 || sec < 0) {
          test = deg + min / 60.0;
        } else {
          test = deg + min / 60.0 + sec / 3600.0;
        }
        // if (ary[3] === "S") {
        //   lat *= -1;
        // }
      }
      if (test > this.maxValue) {
        this.error = this.maxValue + "以下の値を指定してください";
        this.$emit("hasError", false);
        this.dmsParam[this.dmsKey] = null;
        return;
      }
      if (test < this.minValue) {
        this.error = this.minValue + "以上の値を指定してください";
        this.$emit("hasError", false);
        this.dmsParam[this.dmsKey] = null;
        return;
      }
      this.dmsParam[this.dmsKey] = test;
      this.error = "";
      this.$emit("hasError", true);
    },
    CheckInteger() {
      if (!this.regexInteger.test(String(this.dmsParam[this.dmsKey]))) {
        this.error = "整数を入力してください";
        this.$emit("hasError", false);
        return;
      }
      this.error = "";
      this.$emit("hasError", true);
    },
  },
});
